export const checkUserRole = (roles, requiredRoles) => {
  if (!roles || !requiredRoles) return false;
  const hasRole = roles.some((userRole) =>
    requiredRoles.some((requiredRole) => userRole.name === requiredRole),
  );
  return hasRole;
};

export const hasValidToken = (expiryTime) => {
  const dateNow = new Date();
  if (expiryTime * 1000 > dateNow.getTime()) {
    return true;
  }
  return false;
};
